<template>
  <a-button
    v-if="IsShwoOpenTick && typebtn === 'primary'"
    :loading="loading"
    :disabled="false"
    :type="typebtn"
    @click="openTicket"
  >
    {{ btnName }}
  </a-button>
  <a
    :style="{ color: '#2f7bff' }"
    href="javascript:void(0)"
    v-if="IsShwoOpenTick && typebtn === 'text'"
    :loading="loading"
    class="theme-color"
    :type="typebtn"
    @click="openTicket"
  >
    {{ btnName }}
  </a>
  <a-modal
    :confirmLoading="okLoading"
    :centered="true"
    :keyboard="false"
    :mask-closable="false"
    v-model:visible="visible"
    title="完成开票"
    ok-text="确认"
    cancel-text="取消"
    @ok="ok"
    @cancel="onCancel"
    width="600"
    :loading="true"
  >
    <a-form layout="vertical" ref="formRef">
      <uploadFileTable
        :allow-edit="true"
        v-model:value="attachList"
        :biz-id="id"
        :biz-type="attachBizType"
      ></uploadFileTable>
    </a-form>
  </a-modal>
</template>
<script lang="ts">
import { FileRecord } from "@/core/services/file-upload.interface";
import { Modal, message } from "ant-design-vue";
import { defineComponent, computed, reactive, ref, toRefs, watch } from "vue";
import uploadFileTable from "@/biz-components/upload-file-table/index.vue";
import { SignService, updateStatusOffPayment } from "../ticket-manage-btn.service";
import { getCurrentUserId } from "@/utils";
export default defineComponent({
  isGlobal: true,
  name: "OpenTicketBtn",
  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    basicInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 按钮类型
    typebtn: {
      type: String,
      default: "primary",
    },
    // 按钮名称
    btnName: {
      type: String,
      default: "完成开票",
    },
    // 发票地址
    url: {
      type: String,
      default: "",
    },
    attachBizType: {
      type: String,
      default: "",
    },
    bizFileType: {
      type: String,
      default: "INVOICE_APPLICATION",
    },
    el: {
      type: Object,
    },
    btnStatus: {
      type: String,
      default: 'wckp',
    },
    updateStatus: {
      type: String,
      default: "invoiceStatus",
    },
  },
  emits: ["update:basicInfo", "update:attachList", "refresh"],
  components: { uploadFileTable },
  setup(props, { emit }) {
    // 完成开票
    const IsShwoOpenTick = computed(() => {
      return (
        (props.basicInfo.createBy === state.currentUserId || props.basicInfo.finalReviewerFlag) &&
        props.basicInfo.flowStatus == "sptg" &&
        (props.basicInfo[props.updateStatus] == "dkp" ||
          props.basicInfo[props.updateStatus] == "dsp")
      );
    });
    const visible = ref(false);
    const okLoading = ref(false);
    const state = reactive({
      id: computed(() => {
        const t = props.url.split("/");
        return t[t.length - 1];
      }),
      attachList: [] as FileRecord[],
      currentUserId: getCurrentUserId(),
    });

    // 打开弹窗
    const openTicket = () => {
      visible.value = true;
    };

    // 附件上传
    const { run: uploadFiles } = SignService.useContractStatusChangeApi();
    const uploadFilesFn = async () => {
      if (visible.value) {
        const files = state.attachList.map((item) => {
          item.bizId = state.id;
          item.bizType = props.attachBizType;
          return item;
        });
        const res = await uploadFiles(
          files,
          props.basicInfo.id,
          props.bizType,
          props.bizFileType,
          props.btnStatus,
        );
        try {
          if (res.respCode !== "0000") {
            message.error(res.respDesc);
            return;
          }
          message.success(res.respDesc);
          visible.value = false;
        } finally {
          state.attachList = [];
        }
      }
    };

    // 开票申请=>同步 取消申请 改业务状态  资金流
    const { run: runOff } = updateStatusOffPayment();
    const updateStatusOffPaymentData = reactive({
      status: "wckp",
      bizId: props.basicInfo?.invoiceApplicationId,
      bizType: "invoice_application_examine",
    });

    // 完成开票上传附件
    const ok = async () => {
      await uploadFilesFn();
      if (props.bizType === "make_invoice_examine") {
        await runOff(updateStatusOffPaymentData);
      }
      // 刷新详情页附件
      emit("refresh");
    };

    const onCancel = async () => {};

    return {
      ...toRefs(state),
      visible,
      okLoading,
      IsShwoOpenTick,
      ok,
      openTicket,
      onCancel,
    };
  },
});
</script>
